import {validateMaxLength} from '../../common/validationUtils';
import {messages} from '../common/Translations';
import {plainJSTranslator} from "../../common/PlainJSTranslator";


export const validate = values => {
    let errors = {};

    if (Number.isInteger(1 * values.keywordsCount) === false) {
        errors.keywordsCount = 'Must be integer';//plainJSTranslator.formatMessage(messages.mustBeInteger);
    }

    if (!values.keywordsCount) {
        errors.keywordsCount = plainJSTranslator.formatMessage(messages.required);
    }

    if (!values.description) {
        errors.description = plainJSTranslator.formatMessage(messages.required);
    }

    errors = validateMaxLength({values, errors, length: 255, fields: [
            'keywordsCount',
            'description',
        ]});


    return errors;
};


// WEBPACK FOOTER //
// ./web/src/components/keywords-pack/validate.js